// enum STATUS_BADGES {
// 	REGULAR = 'regular',
// 	CHARGEBACK = 'chargeback',
// 	REFUNDED = 'refunded',
// 	CANCELLED = 'cancelled',
// }
//
// enum STATUS_BADGES_TEXT {
// 	'regular' = 'Regular',
// 	'chargeback' = 'Chargeback',
// 	'refunded' = 'Refunded',
// 	'cancelled' = 'Cancelled',
// }

interface IStatusBadge {
	status?: string,
	additionalClasses?: string
	badgeContent?: string | number;
}

export const StatusBadge = ({ status = '', badgeContent, additionalClasses = '' }: IStatusBadge): JSX.Element => {
	try {
		const receivedStatus = status?.toLowerCase();
		let badgeType = 'regular';
		if (receivedStatus === 'cancelled' || receivedStatus === 'pending' || receivedStatus === 'active') {
			badgeType = 'cancelled';
		}

		const badgeClass = `fc-text-overflow main-font-family badge badge-${badgeType} text-capitalize ${additionalClasses} batch-width`;

		return <div className={badgeClass}>{badgeContent ?? receivedStatus}</div>;
	} catch (e) {
		console.log('error in StatusBadge', e);
		return <span></span>;
	}
};
